const SUPPORTED_LOCALES = [
	"ar",
	"bg",
	"bn",
	"bs",
	"ca",
	"cs",
	"da",
	"de",
	"de-formal",
	"el",
	"en",
	"es",
	"et",
	"fa",
	"fi",
	"fr",
	"he",
	"hi",
	"hr",
	"hu",
	"id",
	"it",
	"ja",
	"kk",
	"ko",
	"lt",
	"lv",
	"mn",
	"ms",
	"nl",
	"no",
	"pl",
	"pt",
	"pt-BR",
	"ro",
	"ru",
	"sl",
	"sr",
	"sv",
	"sw",
	"th",
	"tr",
	"uk",
	"vi",
	"zh",
	"zh-CN",
	"zh-TW",
] as const

export function isValidLanguageCode(language: string): boolean {
	return SUPPORTED_LOCALES.includes(
		language as (typeof SUPPORTED_LOCALES)[number],
	)
}

export function validateLanguageCode(language: string): void {
	if (!isValidLanguageCode(language)) {
		throw new Error(
			`Invalid language code: "${language}". Must be one of: ${SUPPORTED_LOCALES.join(", ")}`,
		)
	}
}

export { SUPPORTED_LOCALES }
